import React, { useMemo } from "react";
import { TableSearch } from "../../../components/form/Fields";
import CustomTable from "../../../components/table/CustomTable";
import StatusChip from "../../../components/statusChip/StatusChip";
import { formatMomentDate } from "../../../utils/dateHelper";

const statusBg = (status) => {
    switch (status) {
        case "active":
            return "success";
        case "expired":
            return "secondary";
        case "revoked":
            return "danger";
        default:
            return "";
    }
};

const STATUS_FILTERS = [
    { value: "", label: "All" },
    { value: "active", label: "Active" },
    { value: "expired", label: "Expired" },
    { value: "revoked", label: "Revoked" },
];

const List = ({
    data,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    currentPage,
    limit,
    pagination,
}) => {
    const columns = useMemo(
        () => [
            {
                id: "sr_no",
                header: "SR NO.",
                cell: (_, row, index) => (currentPage - 1) * limit + index + 1,
            },
            {
                id: "user",
                header: "USER",
                className: "text-start",
                cell: (_, row) => {
                    const name = `${row?.first_name || ""} ${row?.last_name || ""}`.trim();
                    return (
                        <div className="d-flex flex-column">
                            <span className="fw-medium">{name || "-"}</span>
                            <small className="text-muted">
                                {row?.mobile_number || row?.email || "-"}
                            </small>
                        </div>
                    );
                },
            },
            {
                id: "started",
                header: "STARTED",
                cell: (_, row) => (row?.starts_at ? formatMomentDate(row.starts_at) : "-"),
            },
            {
                id: "ends",
                header: "ENDS",
                cell: (_, row) => (row?.ends_at ? formatMomentDate(row.ends_at) : "-"),
            },
            {
                id: "days_left",
                header: "DAYS LEFT",
                cell: (_, row) =>
                    row?.display_status === "active" && row?.days_left != null
                        ? `${row.days_left}`
                        : "-",
            },
            {
                id: "status",
                header: "STATUS",
                cell: (_, row) => (
                    <StatusChip
                        bg={statusBg(row?.display_status)}
                        pill
                        title={
                            row?.display_status
                                ? row.display_status.charAt(0).toUpperCase() +
                                  row.display_status.slice(1)
                                : "-"
                        }
                    />
                ),
            },
            {
                id: "converted",
                header: "CONVERTED",
                cell: (_, row) => (
                    <StatusChip
                        bg={row?.converted ? "success" : "secondary"}
                        pill
                        title={row?.converted ? "Yes" : "No"}
                    />
                ),
            },
        ],
        [currentPage, limit]
    );

    return (
        <>
            <div className="p-4 d-flex align-items-center justify-content-between gap-4 flex-wrap">
                <TableSearch
                    value={searchTerm}
                    placeholder="Search by name, email or mobile"
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="d-flex align-items-center gap-2">
                    {STATUS_FILTERS.map((filter) => (
                        <button
                            key={filter.value || "all"}
                            type="button"
                            className={`btn btn-sm ${
                                statusFilter === filter.value
                                    ? "btn-primary"
                                    : "btn-outline-secondary"
                            }`}
                            onClick={() => setStatusFilter(filter.value)}
                        >
                            {filter.label}
                        </button>
                    ))}
                </div>
            </div>

            <CustomTable
                data={data}
                columns={columns}
                emptyMessage="No GIS trials yet"
                keyField="id"
                pagination={pagination}
            />
        </>
    );
};

export default List;
